/**************************************************
 * Nombre:       Home_Mas_Vendidos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TextoTitulo from "./SubComponentes/TextoTitulo";
import Lista_Productos from "./SubComponentes/Lista_Productos";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Home_Mas_Vendidos = () => {
    const [productos, setProductos] = useState([]);

    useEffect(() => {


        let w = [where('estado', '==', 'Publicado'), where('masVendido', '==', true)]
        obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
            if (dox.res) {
                setProductos(dox.data);
            }
        })


    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <TextoTitulo titulo={'LO MAS'} negrita={'VENDIDO'} texto={'DE LA SEMANA'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Lista_Productos items={productos}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Mas_Vendidos  